"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CounterProps_1 = require("./CounterProps");
var styles = require("./Counter.css");
var icons = require("../../../styles/att-icons.css");
var Tooltip_1 = require("../Tooltip");
var TooltipProps_1 = require("../Tooltip/TooltipProps");
var CounterStylesMaps_1 = require("./CounterStylesMaps");
var Counter = /** @class */ (function (_super) {
    __extends(Counter, _super);
    function Counter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentVal: _this.props.options.currentVal || _this.props.options.minLimit,
            minusBtnDisable: _this.props.options.readOnly,
            minusToolTipText: _this.props.options.minusBtnMinTooltipText,
            plusBtnDisable: _this.props.options.readOnly,
            plusToolTipText: _this.props.options.plusBtnMaxTooltipText,
            showMinusToolTip: false,
            showPlusToolTip: false,
        },
            _this.onCounterBtnClick = _this.onCounterBtnClick.bind(_this);
        _this.checkAndSet = _this.checkAndSet.bind(_this);
        _this.onminusmouseout = _this.onminusmouseout.bind(_this);
        _this.onminusmouseover = _this.onminusmouseover.bind(_this);
        _this.onplusmouseout = _this.onplusmouseout.bind(_this);
        _this.onplusmouseover = _this.onplusmouseover.bind(_this);
        return _this;
    }
    Counter.prototype.onCounterBtnClick = function (e) {
        var _this = this;
        var etargeName = e.currentTarget.name;
        var counterVal = this.state.currentVal;
        var action = '';
        if (etargeName === Counter.btnProps.minusBtnName) {
            if (this.state.currentVal > this.props.options.minLimit) {
                action = 'MINUS';
                counterVal = counterVal - 1;
                this.setState({ currentVal: counterVal }, function () { return _this.checkAndSet(); });
            }
        }
        else if (etargeName === Counter.btnProps.plusBtnName) {
            if (this.state.currentVal < this.props.options.maxLimit) {
                action = 'PLUS';
                counterVal = counterVal + 1;
                this.setState({ currentVal: counterVal }, function () { return _this.checkAndSet(); });
            }
        }
        this.props.events.onClick(counterVal, action);
    };
    Counter.prototype.componentWillMount = function () {
        if (!this.props.options.readOnly) {
            this.checkAndSet();
        }
    };
    Counter.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.options.maxLimit !== prevProps.options.maxLimit
            || this.props.options.minLimit !== prevProps.options.minLimit) {
            this.checkAndSet();
        }
    };
    Counter.prototype.checkAndSet = function () {
        if (this.state.currentVal === this.props.options.minLimit
            || this.state.currentVal === this.props.options.maxLimit) {
            if (this.state.currentVal === this.props.options.minLimit) {
                this.setState({ minusBtnDisable: true });
            }
            else {
                this.setState({ minusBtnDisable: false });
            }
            if (this.state.currentVal === this.props.options.maxLimit) {
                this.setState({ plusBtnDisable: true });
            }
            else {
                this.setState({ plusBtnDisable: false });
            }
        }
        else {
            this.setState({ minusBtnDisable: false, plusBtnDisable: false });
        }
    };
    Counter.prototype.onminusmouseover = function () {
        var showMinusTT = this.state.minusToolTipText && this.state.minusBtnDisable;
        this.setState({ showMinusToolTip: showMinusTT });
    };
    Counter.prototype.onminusmouseout = function () {
        this.setState({ showMinusToolTip: false });
    };
    Counter.prototype.onplusmouseover = function () {
        var showPlusTT = this.state.plusToolTipText && this.state.plusBtnDisable;
        this.setState({ showPlusToolTip: showPlusTT });
    };
    Counter.prototype.onplusmouseout = function () {
        this.setState({ showPlusToolTip: false });
    };
    Counter.prototype.render = function () {
        if (this.props.options && this.props.options.type === CounterProps_1.CounterBackgroundType.ICON
            && !this.props.options.backgroundIcon) {
            return (' for type === icon backgroundIcon is requred');
        }
        else if (this.props.options && this.props.options.type === CounterProps_1.CounterBackgroundType.IMAGE
            && !this.props.options.backgroundImageClass) {
            return (' for type === Image backgroundImageClass is requred and ' +
                ' add background: url() in the class you are passing');
        }
        else {
            var iclasses = [];
            var counterTextClass = [];
            if (this.props.options.backgroundIcon) {
                iclasses.push(icons.attIcon);
                iclasses.push(this.getIcon(this.props.options));
                iclasses.push(styles.backgroundIcon);
                counterTextClass.push(styles.backgroundIconFont);
            }
            var counterInnterHtml = void 0;
            if (this.props.options.type === CounterProps_1.CounterBackgroundType.IMAGE) {
                counterInnterHtml = (React.createElement("span", { className: [this.props.options.backgroundImageClass, styles.counterNumber].join(' '), style: { color: this.props.options.counterTextColor } },
                    React.createElement("span", { className: counterTextClass.join(' ') }, this.state.currentVal)));
            }
            else {
                counterInnterHtml = (React.createElement("span", { className: styles.counterNumber, style: { color: this.props.options.counterTextColor } },
                    React.createElement("i", { className: iclasses.join(' ') }),
                    React.createElement("span", { className: counterTextClass.join(' ') }, this.state.currentVal)));
            }
            return (React.createElement("div", { className: styles.container },
                React.createElement("button", { type: "button", "aria-label": this.props.options.catoTextMinus, name: Counter.btnProps.minusBtnName, className: [
                        this.state.minusBtnDisable ? styles.counterBtnDisable : styles.counterBtnActive, styles.counterBtn
                    ]
                        .join(' '), onClick: this.onCounterBtnClick, disabled: this.state.minusBtnDisable, onMouseOver: this.onminusmouseover, onMouseOut: this.onminusmouseout },
                    React.createElement("i", { className: [icons.attIcon, icons.attIconMinus, styles.iconSizem].join(' ') }),
                    React.createElement(Tooltip_1.default, { data: { type: TooltipProps_1.TooltipTypes.FIXED_CONTROLLED, showTooltip: this.state.showMinusToolTip } }, this.state.minusToolTipText)),
                counterInnterHtml,
                React.createElement("button", { type: "button", "aria-label": this.props.options.catoTextPlus, name: Counter.btnProps.plusBtnName, className: [
                        this.state.plusBtnDisable ? styles.counterBtnDisable : styles.counterBtnActive, styles.counterBtn
                    ]
                        .join(' '), onClick: this.onCounterBtnClick, disabled: this.state.plusBtnDisable, onMouseOver: this.onplusmouseover, onMouseOut: this.onplusmouseout },
                    React.createElement("i", { className: [icons.attIcon, icons.attIconPlus, styles.iconSizem].join(' ') }),
                    React.createElement(Tooltip_1.default, { data: { type: TooltipProps_1.TooltipTypes.FIXED_CONTROLLED, showTooltip: this.state.showPlusToolTip } }, this.state.plusToolTipText))));
        }
    };
    Counter.prototype.getIcon = function (options) {
        return CounterStylesMaps_1.iconMap.get(options.backgroundIcon);
    };
    Counter.defaultProps = {
        options: {
            catoTextMinus: 'minus',
            catoTextPlus: 'plus',
            maxLimit: 10,
            minLimit: 0,
            readOnly: false,
        },
    };
    Counter.btnProps = {
        minusBtnName: 'minus',
        plusBtnName: 'plus',
    };
    return Counter;
}(React.Component));
exports.default = Counter;
//# sourceMappingURL=Counter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Counter/Counter.js
// module id = 1125
// module chunks = 8